module.exports = __webpack_public_path__ + "TB_Warning_Melody_B.wav.660677da.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/warning/TB_Warning_Melody_B.wav.mp3
// module id = 511
// module chunks = 0